export default __webpack_public_path__ + "static/media/carbon-protocol-image.e8fc1d4c.png";